import React from "react";
import CookieConsent from "react-cookie-consent";
import ReactGA from "react-ga4";

const CookieBanner = () => {
  const handleAccept = () => {
    // Detta körs ENDAST när användaren klickar på "Acceptera"
    ReactGA.initialize("G-HS4EXVEF95"); 
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    console.log("Analytics startat efter samtycke.");
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Jag förstår"
      declineButtonText="Neka"
      enableDeclineButton
      onAccept={handleAccept}
      cookieName="mag_user_consent"
      style={{ 
        background: "rgba(26, 26, 26, 0.9)", 
        backdropFilter: "blur(10px)",
        color: "#fff",
        fontFamily: "Inter, sans-serif",
        fontSize: "0.85rem",
        padding: "10px 30px",
        margin: "20px",
        width: "calc(100% - 40px)", // Ger lite luft på sidorna
        borderRadius: "12px",
        bottom: "20px", // Lyfter upp den från kanten
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        alignItems: "center"
      }}
      buttonStyle={{ 
        background: "#a68b5a", 
        color: "#fff", 
        fontSize: "0.8rem",
        padding: "10px 25px",
        borderRadius: "4px",
        textTransform: "uppercase",
        fontWeight: "600"
      }}
      declineButtonStyle={{ 
        background: "transparent", 
        color: "#888", 
        fontSize: "0.8rem",
        textDecoration: "underline"
      }}
      expires={150}
    >
      Vi använder cookies för att förbättra din upplevelse och analysera trafik på webbplatsen. 
      Läs mer i vår <a href="/policy" style={{ color: "#a68b5a" }}>personuppgiftspolicy</a>.
    </CookieConsent>
  );
};

export default CookieBanner;